import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Sets 'mismatch' on the confirm control itself (not on the group), so kendo-formfield shows the error.
// The caller must re-run validation on this control when the other control changes.
export function MatchControlValidator(otherControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const other = control.parent?.get(otherControlName);
    return other && control.value !== other.value ? { mismatch: true } : null;
  };
}
